/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportBoxController', IncidentReportBoxController);

    IncidentReportBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function IncidentReportBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.critical = 0;

        // vm.abnormal = PatientResult.countAbnormal({id: facility.id});
    }
})();
